import store from "../store";
import { IConfigurationRegistry } from "./configuration";
import { IAuthenticationRegistry } from "./authentication";
import { IFolderRegistry } from "./folder";
import { IFileRegistry } from "./file";
import { IHistoryRegistry } from "./history";
import { ConfigurationRegistry } from "../infrastructure/configuration";
import { AuthenticationRegistry } from "../infrastructure/authentication";
import { FolderRegistry } from "../infrastructure/folder";
import { FileRegistry } from "../infrastructure/file";
import { HistoryRegistry } from "../infrastructure/history";

export class DomainRegistry {
  // シングルトンインスタンス.
  static readonly instance: DomainRegistry = new DomainRegistry();

  constructor() {
    this.configuration = new ConfigurationRegistry();
    this.authentication = new AuthenticationRegistry(this.getToken);
    this.file = new FileRegistry(this.getToken);
    this.folder = new FolderRegistry(this.getToken);
    this.history = new HistoryRegistry(this.getToken);
  }

  public readonly configuration: IConfigurationRegistry;
  public readonly authentication: IAuthenticationRegistry;
  public readonly file: IFileRegistry;
  public readonly folder: IFolderRegistry;
  public readonly history: IHistoryRegistry;
  protected getToken: () => string = () => store.getters.token;

  static get configuration(): IConfigurationRegistry {
    return DomainRegistry.instance.configuration;
  }
  static get authentication(): IAuthenticationRegistry {
    return DomainRegistry.instance.authentication;
  }
  static get file(): IFileRegistry {
    return DomainRegistry.instance.file;
  }
  static get folder(): IFolderRegistry {
    return DomainRegistry.instance.folder;
  }
  static get history(): IHistoryRegistry {
    return DomainRegistry.instance.history;
  }
}
